import(/* webpackMode: "eager" */ "/opt/render/project/src/src/app/terms/page.js");
